import type { GuardSignalKind } from '@nadoutong/contracts';
import { useT } from '../../../i18n/index.ts';
import { cx } from '../../../ui/index.ts';
import { NumberField } from './GuardControls.tsx';
import type { GuardIssue, TripDraft } from './guardModel.ts';

/** Window / hits / ratio / hold of one trip rule; dimmed while the trip is off. */
export function GuardTripFields({
  kind,
  prefix,
  trip,
  issues,
  disabled,
  onChange,
  onEnter,
}: {
  readonly kind: GuardSignalKind;
  /** testId prefix: `guaranteed-guard-sku` or `guaranteed-guard-org`. */
  readonly prefix: string;
  readonly trip: TripDraft;
  readonly issues: ReadonlyMap<string, GuardIssue>;
  readonly disabled: boolean;
  readonly onChange: (trip: TripDraft) => void;
  readonly onEnter?: () => void;
}): JSX.Element {
  const t = useT();
  const off = trip.mode === 'off';
  const field = (
    key: 'window' | 'hits' | 'ratio' | 'hold',
    label: Parameters<typeof t>[0],
    unit: Parameters<typeof t>[0],
  ): JSX.Element => (
    <NumberField
      label={t(label)}
      unit={unit}
      value={trip[key]}
      issue={issues.get(`${kind}.trip.${key}`)}
      disabled={disabled}
      testId={`${prefix}-${kind}-trip-${key}`}
      onChange={(text) => onChange({ ...trip, [key]: text })}
      onEnter={onEnter}
    />
  );
  return (
    <div className={cx('transition-opacity duration-120', off && 'opacity-50')} data-off={off || undefined}>
      {field('window', 'guaranteed.guard.field.window', 'guaranteed.guard.unit.seconds')}
      {field('hits', 'guaranteed.guard.field.min_hits', 'guaranteed.guard.unit.times')}
      {field('ratio', 'guaranteed.guard.field.min_ratio', 'guaranteed.guard.unit.percent')}
      {field('hold', 'guaranteed.guard.field.max_hold', 'guaranteed.guard.unit.seconds')}
    </div>
  );
}
